// extracted by mini-css-extract-plugin
export default {"image":"Product_image__N3ID6"};